import { render, staticRenderFns } from "./PartnerDetail.vue?vue&type=template&id=672b1f6e&"
import script from "./PartnerDetail.vue?vue&type=script&lang=js&"
export * from "./PartnerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports